import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import StepLayout from "../../components/StepLayout/StepLayout";
import { useTunnelDispatch, useTunnelState } from "../../context/TunnelContext";
import { SERVICES } from "../../utils/mockData";

export default function ServiceSelection() {
  const navigate = useNavigate();
  const dispatch = useTunnelDispatch();
  const { currentShoe } = useTunnelState();

  useEffect(() => {
    if (!currentShoe.gum) {
      navigate("/nouvelle-demande/marque", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function selectService(serviceId) {
    dispatch({ type: "SET_SERVICE", service: serviceId });
    navigate("/nouvelle-demande/recapitulatif-chaussure");
  }

  return (
    <StepLayout title="Choix du service">
      <Stack spacing={3} sx={{ maxWidth: 640 }}>
        {SERVICES.map((service) => (
          <Card key={service.id} variant="outlined">
            <CardContent>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography variant="h6">{service.label}</Typography>
                <Typography variant="h6">{service.price} €</Typography>
              </Stack>
              <Typography variant="body2" color="text.secondary">
                {service.description}
              </Typography>
              {service.notice && (
                <Typography
                  variant="caption"
                  color="warning.main"
                  sx={{ display: "block", mt: 1 }}
                >
                  {service.notice}
                </Typography>
              )}
            </CardContent>
            <CardActions>
              <Button
                variant="contained"
                onClick={() => selectService(service.id)}
              >
                Choisir
              </Button>
            </CardActions>
          </Card>
        ))}
      </Stack>
    </StepLayout>
  );
}
